export const ROUTES = {
  HOME: "/",
  PLAYGROUND: "/playground",
  EXPLORE: "/explore",
  PAIR: "/pair",
  HELP: "/help",
  TERMS: "/terms",
  PRIVACY_POLICY: "/privacy-policy",
  CONTACT: "/contact",
};
